var PreselectedCarABTestingJS = (function ($) {

    var speedIndexes = {
        '': 0,
        'A1': 1,
        'A2': 2,
        'A3': 3,
        'A4': 4,
        'A5': 5,
        'A6': 6,
        'A7': 7,
        'A8': 8,
        'B': 9,
        'C': 10,
        'D': 11,
        'E': 12,
        'F': 13,
        'G': 14,
        'J': 15,
        'K': 16,
        'L': 17,
        'M': 18,
        'N': 19,
        '(N)': 20,
        'P': 21,
        'Q': 22,
        'R': 23,
        'S': 24,
        'SR': 25,
        'T': 26,
        'U': 27,
        'H': 28,
        'HR': 29,
        '(H)': 30,
        'VR': 31,
        'V': 32,
        '(V)': 33,
        'Z': 34,
        'ZR': 35,
        '(ZR)': 36,
        'W': 37,
        '(W)': 38,
        'Y': 39,
        '(Y)': 40,
        'ZR,W,Y': 41
    };

    var speedIndexMessages = {
        'A1' : ACC.speedIndexA1,
        'A2' : ACC.speedIndexA2,
        'A3' : ACC.speedIndexA3,
        'A4' : ACC.speedIndexA4,
        'A5' : ACC.speedIndexA5,
        'A6' : ACC.speedIndexA6,
        'A7' : ACC.speedIndexA7,
        'A8' : ACC.speedIndexA8,
        'B' : ACC.speedIndexB,
        'C' : ACC.speedIndexC,
        'D' : ACC.speedIndexD,
        'E' : ACC.speedIndexE,
        'F' : ACC.speedIndexF,
        'G' : ACC.speedIndexG,
        'J' : ACC.speedIndexJ,
        'K' : ACC.speedIndexK,
        'L' : ACC.speedIndexL,
        'M' : ACC.speedIndexM,
        'N' : ACC.speedIndexN,
        '(N)' : ACC.speedIndexParN,
        'P' : ACC.speedIndexP,
        'Q' : ACC.speedIndexQ,
        'R' : ACC.speedIndexR,
        'S' : ACC.speedIndexS,
        'SR' : ACC.speedIndexSR,
        'T' : ACC.speedIndexT,
        'U' : ACC.speedIndexU,
        'H' : ACC.speedIndexH,
        'HR' : ACC.speedIndexHR,
        '(H)' : ACC.speedIndexParH,
        'VR' : ACC.speedIndexVR,
        'V' : ACC.speedIndexV,
        '(V)' : ACC.speedIndexParV,
        'Z' : ACC.speedIndexZ,
        'ZR' : ACC.speedIndexZR,
        '(ZR)' : ACC.speedIndexParZR,
        'W' : ACC.speedIndexW,
        '(W)' : ACC.speedIndexParW,
        'Y' : ACC.speedIndexY,
        '(Y)' : ACC.speedIndexParY,
        'ZR,W,Y': ACC.speedIndexZRWY
    };

    var highSpeedIndexes = ["ZR", "(ZR)", "W", "(W)", "Y", "(Y)"];
    var vehicleTypesForDisplayingPreselectedCar = ["OFF", "ALL_TERRAIN_OFF", "MUD_TERRAIN_OFF", "HIGHWAY_TERRAIN_OFF", "PKW",
        "LLKW", "VINTAGE_PKW", "VINTAGE_LLKW", "RACE_PKW", "SL", "FB"];
    var vehicleTypesNotForDisplaying = ["MO", "LKW", "AS"];


    function ifPreselectedCarChosenSerp() {
        var vehicleData;

        if (window.localStorage.getItem('tyreVehicleData') && $(".selected_car_info_block_ab").length
            && vehicleTypesForDisplayingPreselectedCar.indexOf($('input[name=vehicleTypes]').val()) !== -1) {
            vehicleData = JSON.parse(window.localStorage.getItem('tyreVehicleData'));

            if (!vehicleData.width && !vehicleData.tyreProfile && !vehicleData.size ) {
                return;
            }

            $("#width").on("change", function (event) {
                if ($(".preselectedCar-ab-testing").length > 0) {
                    event.stopPropagation();
                    event.stopImmediatePropagation();
                    showConfirmMessagePopup();
                    $("#width").val(vehicleData.width ? vehicleData.width : getParamFromUrl("width"));
                }

            });

            $("#profile").on("change", function (event) {
                if ($(".preselectedCar-ab-testing").length > 0) {
                    event.stopPropagation();
                    event.stopImmediatePropagation();
                    showConfirmMessagePopup();

                    $("#profile").val(vehicleData.tyreProfile ? vehicleData.tyreProfile : getParamFromUrl("profile"));
                }
            });

            $("#size").on("change", function (event) {
                if ($(".preselectedCar-ab-testing").length > 0) {
                    event.stopPropagation();
                    event.stopImmediatePropagation();
                    showConfirmMessagePopup();

                    $("#size").val(vehicleData.size ? vehicleData.size : getParamFromUrl("size"));
                }

            });

            var $loadIndex = $("#load-index");
            $loadIndex.on("change", function (event) {
                if ($(".preselectedCar-ab-testing").length > 0) {
                    var parsedLoadIndex = isNaN(parseInt($loadIndex.val())) ? 0 : parseInt($loadIndex.val());
                    if (vehicleData.loadIndex && $loadIndex.val() !== null && parsedLoadIndex < parseInt(vehicleData.loadIndex)) {
                        event.stopPropagation();
                        event.stopImmediatePropagation();
                        showConfirmMessagePopup();
                        var loadIndexValue = getParamFromUrl("loadIndex");
                        $loadIndex.val(loadIndexValue ? loadIndexValue : vehicleData.loadIndex);
                    }
                }

            });

            var $speedRating = $("#speed-rating");
            $speedRating.on("change", function (event) {
                if ($(".preselectedCar-ab-testing").length > 0) {
                    if (vehicleData.speedRating && $speedRating.val() !== null
                        && speedIndexes[$speedRating.val()] < speedIndexes[vehicleData.speedRating]) {
                        event.stopPropagation();
                        event.stopImmediatePropagation();
                        showConfirmMessagePopup();
                        var speedRatingValue = getParamFromUrl("speedRating");
                        if (highSpeedIndexes.indexOf(speedRatingValue) !== -1 || (!speedRatingValue && highSpeedIndexes.indexOf(vehicleData.speedRating) !== -1)) {
                            $speedRating.val("ZR,W,Y")
                        } else {
                            $speedRating.val(speedRatingValue ? speedRatingValue : vehicleData.speedRating);
                        }
                    }
                }
            });
        }
    }

    function getParamFromUrl(queryParam) {
        var results = new RegExp('[\?&]' + queryParam + '=([^&#]*)').exec(window.location.href);
        return (results !== null && results[1]) ? decodeURIComponent(results[1]) : "";
    }

    function showConfirmMessagePopup() {
        var $resetPreselectedCar = $("#confirm-reset-preselectedCar-popup-tmpl:not(.popup-disabled)");

        $.fancybox({
            maxWidth: 350,
            maxHeight: 150,
            autoHeight: true,
            content: $resetPreselectedCar.html().trim(),
            autoSize: false,
            helpers: {
                overlay: {
                    locked: false
                }
            }
        });
    }

    function updateDataInSearchFormEbon() {
        if($("#search-filter-width").hasClass("reset-preselected-car-class")) {
            return;
        }

        var ebonHomeSearchButton = $("#searchForm .search-filter-footer__result-button.btn-wrapper");
        var vehicleType = $(".search-filter-tab-1 #searchForm input[name=vehicleTypes]");

        if (window.localStorage.getItem('tyreVehicleData')
            && vehicleTypesForDisplayingPreselectedCar.indexOf(vehicleType.val()) !== -1
            && $(".search-filter-tab-1").is(":visible")) {

            $("#search-filter-width").addClass("reset-preselected-car-class");
            $("#search-filter-profile").addClass("reset-preselected-car-class");
            $("#search-filter-size").addClass("reset-preselected-car-class");

            resetPreselectedCar(ebonHomeSearchButton);
        }
        ebonHomeSearchButton.on("click", function() {
            if(window.localStorage.getItem('tyreVehicleData') && $(".vehicleType.j-sf-input").length && vehicleTypesNotForDisplaying.indexOf($(".vehicleType.j-sf-input").val()) === -1) {
                var vehicleData = JSON.parse(window.localStorage.getItem('tyreVehicleData'));
                if (vehicleData.loadIndex) {
                    if ($("#loadIndex").length > 0) {
                        $("#loadIndex").val(vehicleData.loadIndex);
                    } else {
                        $("form#searchForm").append('<input type="hidden" id="loadIndex" name="loadIndex" value=' + vehicleData.loadIndex + ' />');
                    }
                }
                if (vehicleData.speedRating) {
                    if ($("#speedRating").length > 0) {
                        $("#speedRating").val(vehicleData.speedRating);
                    } else {
                        $("form#searchForm").append('<input type="hidden" id="speedRating" name="speedRating" value=' + vehicleData.speedRating + ' />');
                    }
                }
            }
        });
    }

    function updateDataInSearchForm($submitFormButton) {
        var vehicleType = $submitFormButton.closest("form").find("input[name='vehicleTypes']").val();

        if (window.localStorage.getItem('tyreVehicleData')
            && (vehicleTypesForDisplayingPreselectedCar.indexOf(vehicleType) !== -1
                || $('input[name=isRunflat]').val()
                || $("#priceCategory").val() === "refurbished")) {
            var vehicleData = JSON.parse(window.localStorage.getItem('tyreVehicleData'));

            if (!vehicleData.width && !vehicleData.tyreProfile && !vehicleData.size) {
                return;
            }

            var width = $("#width");
            width.addClass("reset-preselected-car-class");
            var preselectedCarWidth = vehicleData.width;
            width.val(preselectedCarWidth);

            if(width.val() === null || width.val() === "") {
                $("#width option").each(function () {
                $(this).removeAttr('selected'); });
                showNotAvailableParameter(width, preselectedCarWidth);
            }
            width.trigger("change");

            var profile = $("#profile");
            profile.addClass("reset-preselected-car-class");
            var preselectedCarProfile = vehicleData.tyreProfile;
            profile.val(preselectedCarProfile);

            if(profile.val() === null || profile.val() === "") {
                $("#profile option").each(function () {
                $(this).removeAttr('selected'); });
                showNotAvailableParameter(profile, preselectedCarProfile);
            }
            profile.trigger("change");

            var size = $("#size");
            size.addClass("reset-preselected-car-class");
            var preselectedCarSize = vehicleData.size;
            size.val(preselectedCarSize);


            if(size.val() === null || size.val() === "") {
                $("#size option").each(function () {
                    $(this).removeAttr('selected');
                });
                showNotAvailableParameter(size, preselectedCarSize);
            }
            size.trigger("change");

            var loadIndex = $("#loadIndex");
            $("#loadIndex").addClass("reset-preselected-car-class");
            var preselectedLoadIndex = vehicleData.loadIndex;
            loadIndex.val(preselectedLoadIndex);

            var loadIndexOptions = [];
            $('#loadIndex option').each(function() {
                loadIndexOptions.push($(this).val());
            });

            if(loadIndex.length > 0) {
                if(preselectedLoadIndex !== null && loadIndexOptions.indexOf(preselectedLoadIndex) !== null) {
                    $.each(loadIndexOptions, function(index, availableIndex) {
                        if(availableIndex > preselectedLoadIndex){
                            loadIndex.val(availableIndex);
                            return false;
                        }
                    });
                }

                if(loadIndex.val() === null || loadIndex.val() === "") {
                    $("#loadIndex option").each(function () { $(this).removeAttr('selected'); });
                    loadIndex.val(loadIndexOptions[loadIndexOptions.length - 1]);
                }
            } else {
                if (vehicleData.loadIndex) {
                    $("form#searchForm").append('<input type="hidden" id="loadIndex" name="loadIndex" value=' + vehicleData.loadIndex + ' />');
                }
            }
            loadIndex.addClass("reset-preselected-car-class");

            var speedRating = $("#speedRating");
            speedRating.addClass("reset-preselected-car-class");
            var preselectedSpeedRating = vehicleData.speedRating;
            speedRating.val(preselectedSpeedRating);

            var speedRatingOptions = [];
            $('#speedRating option').each(function() {
                speedRatingOptions.push($(this).val());
            });
            if (speedRating.length > 0) {
                if(preselectedSpeedRating !== null && speedRatingOptions.indexOf(preselectedSpeedRating) === -1) {
                    $.each(speedRatingOptions, function(index, value) {
                        if(speedIndexes[value] > speedIndexes[preselectedSpeedRating]) {
                            speedRating.val(value);
                            return false;
                        }
                    });
                }
                if(highSpeedIndexes.indexOf(vehicleData.speedRating) !== -1) {
                    speedRating.val("ZR,W,Y");
                }
                if(speedRating.val() === null || speedRating.val() === "") {
                    $("#speedRating option").each(function () { $(this).removeAttr('selected'); });
                    speedRating.val(speedRatingOptions[speedRatingOptions.length - 1]);
                }
                $("#speedRating").trigger("change");
            } else {
                if (vehicleData.speedRating) {
                    $("form#searchForm").append('<input type="hidden" id="speedRating" name="speedRating" value=' + vehicleData.speedRating + ' />');
                }
            }

            resetPreselectedCar($submitFormButton);
            ifNotSelectedAllDimensions($submitFormButton);
        }
    }
    function showNotAvailableParameter($searchFormParam, $preselectedCarParam) {
        $searchFormParam.append($("<option>", {
            value : $preselectedCarParam,
            text : $preselectedCarParam,
            selected : "selected",
            class : "not-available-parameter"})).addClass("not-available-parameter");
    }

    function showNotAvailableSpeedRating($searchFormParam, $preselectedCarParam) {
        $searchFormParam.append($("<option>", {
            value : $preselectedCarParam,
            text : speedIndexMessages[$preselectedCarParam],
            selected : "selected",
            class : "not-available-parameter"})).addClass("not-available-parameter");
    }

    function resetPreselectedCar($submitFormButton) {
        $(".reset-preselected-car-class").on("change", function () {

            if($(".vehicleType.j-sf-input").length && vehicleTypesNotForDisplaying.indexOf($(".vehicleType.j-sf-input").val()) !== -1) {
                return;
            }

            var vehicleData = JSON.parse(window.localStorage.getItem('tyreVehicleData'));

            if($(this).is("#speedRating") && vehicleData && speedIndexes[$(this).val()] > speedIndexes[vehicleData.speedRating]) {
                return;
            }

            window.localStorage.removeItem('tyreVehicleData');
            $.get('/resetPreselectedCar');

            if ($("#loadIndex").length && $("#loadIndex").is(":hidden")) {
                $("#loadIndex").remove();
            }
            if ($("#speedRating").length && $("#speedRating").is(":hidden")) {
                $("#speedRating").remove();
            }

            var $this = $(this);
            $this.closest("form").find("select.not-available-parameter").removeClass("not-available-parameter");
            $this.closest("form").find("option.not-available-parameter").remove();
            if ($submitFormButton.is(":disabled") && $(".j-results-message").length === 0) {
                $submitFormButton.attr("disabled", false);
            }

            if (($this.is("#width") || $this.is("#profile") || $this.is("#size")) && $("#speedRating").val() === null) {
                $("#speedRating").val("");
                $("#speedRating").trigger("change");
            }
        })
    }

    function ifNotSelectedAllDimensions($submitFormButton) {

        if ($(".not-available-parameter").length > 0) {
            $submitFormButton.attr("disabled", true);
            var message = ACC.getParametrizedString(ACC.searchResultsNumberNoResults, "highlighted values");
            $(".results-counter .j-results-message").addClass("no-search-results-message");
            $(".results-counter .j-results-message").text(message);
        }
    }

    function enablePreselectedCarAbTesting() {
        window.localStorage.setItem('enablePreselectedCarAbTesting', true);
        settingPreselectedCarAbTesting();
    }

    function settingPreselectedCarAbTesting() {

        $(".container .results-filters-form").addClass("preselectedCar-ab-testing");
        $(".car-selector-field-wrapper").addClass("car-selector-field");
        $("#selected_car_info_wrapper").hide();
        //giga
        $("#filterForm.filterFormWrapper").append('<input type="hidden" name="enablePreselectedCarAB" value=true />');

        $(".search-filter-container #searchForm").append('<input type="hidden" name="enablePreselectedCarAB" value=true />');
        $("#submit_button #search, #s_q #search, #suchen4, #valid.btn").append('<input type="hidden" name="enablePreselectedCarAB" value=true />');
        $("#searchByBrandForm").append('<input type="hidden"' + ' name="enablePreselectedCarAB" value=true />');

        updateDataInSearchFormEbon();

        if ($("#submit_button #search").length || $("#s_q #search").length || $("#suchen4").length || $("#valid.btn").length || $("#searchEbon").length ) {

            var submitFormButton;

            if ($("#submit_button #search").length) {
                submitFormButton = $("#submit_button #search");
            } else {
                if ($("#s_q #search").length) {
                    submitFormButton = $("#s_q #search");
                } else {
                    if ($("#suchen4").length) {
                        submitFormButton = $("#suchen4");
                    } else if ($("#searchEbon").length) {
                        submitFormButton = $("#searchEbon");
                    } else {
                        submitFormButton = $("#valid.btn");
                    }
                }
            }
            updateDataInSearchForm(submitFormButton);
        }

        //menu ebon
        $(".navbar-collapse .top-navigation-list").find("a").each(function () {
            changeLinksAbTesting($(this))
        });
        // menu rd, lite
        $(".navbar-collapse .navbar-nav.navbar-right").find("a").each(function () {
            changeLinksAbTesting($(this))
        });
        //menu giga
        $(".navbar-collapse .nav.nav-pills").find("a").each(function () {
            changeLinksAbTesting($(this))
        });
        //breadcrumbs
        $(".content-breadcrumb").find("a").slice(1).each(function () {
            changeLinksAbTesting($(this))
        });
        $(".breadcrumb_navigation_row span").find("a").slice(1).each(function () {
            changeLinksAbTesting($(this))
        });

        var backLinkEbon = $("#backLink");
        if(backLinkEbon.length > 0) {
            var link = backLinkEbon.attr('href');
            backLinkEbon.attr('href', link + "&enablePreselectedCarAB=true");
        }
        var backLinkGigaSign = $(".breadcrumbsComponent .back-to-search-button");
        if(backLinkGigaSign.length > 0) {
            var link = backLinkGigaSign.attr('href');
            backLinkGigaSign.attr('href', link + "&enablePreselectedCarAB=true");
        }
        var backLinkGiga = $(".breadcrumbsComponent strong a");
        if(backLinkGiga.length > 0) {
            var link = backLinkGiga.attr('href');
            backLinkGiga.attr('href', link + "&enablePreselectedCarAB=true");
        }
        var backLinkLiteSign = $(".breadcrumb_navigation_row .back-to-search-button");
        if(backLinkLiteSign.length > 0) {
            var link = backLinkLiteSign.attr('href');
            backLinkLiteSign.attr('href', link + "&enablePreselectedCarAB=true");
        }
        var backLinkLite = $(".breadcrumb_navigation_row strong a");
        if(backLinkLite.length > 0) {
            var link = backLinkLite.attr('href');
            backLinkLite.attr('href', link + "&enablePreselectedCarAB=true");
        }

        //footers
        //ebon
        $(".footer-nav-container .footer-simple-links-column-container").slice(0, 3).find("a").each(function () {
            changeLinksAbTesting($(this));
        });

        $(".manufacturerMap .manufacturer").find("a").each(function () {
            changeLinksAbTesting($(this));
        });

        //lite
        $("#footerNavLinks #seoLinks").find("a").each(function () {
            changeLinksAbTesting($(this));
        });
        //giga
        $(".footer .footerBoxContainer").find("a").each(function () {
            changeLinksAbTesting($(this));
        });
    }

    function changeLinksAbTesting($this) {
        var link = $this.attr('href');
        if (!link || ifLinkEndsWith(link, ".html")) {
            return;
        }
        if (link.indexOf("?") !== -1) {
            $this.attr('href', link + "&enablePreselectedCarAB=true");
        } else {
            $this.attr('href', link + "?enablePreselectedCarAB=true");
        }

    }

    function ifLinkEndsWith(str, suffix) {
        return str.indexOf(suffix, str.length - suffix.length) !== -1;
    }

    function disablePreselectedCarAbTesting() {
        window.localStorage.removeItem('enablePreselectedCarAbTesting');
        removeSettingPreselectedCarAbTesting();
    }

    function removeSettingPreselectedCarAbTesting() {

        $(".container .results-filters-form").removeClass("preselectedCar-ab-testing");
        $(".car-selector-field-wrapper").removeClass("car-selector-field");
        $("#selected_car_info_wrapper").show();

        $(".search-filter-container #searchForm input[name='enablePreselectedCarAB']").remove();
        $("#submit_button #search input[name='enablePreselectedCarAB']").remove();
        $("#s_q #search input[name='enablePreselectedCarAB']").remove();
        $("#suchen4 input[name='enablePreselectedCarAB']").remove();
        $("#valid.btn input[name='enablePreselectedCarAB']").remove();
        $("#searchByBrandForm input[name='enablePreselectedCarAB']").remove();

        $(".search-filter-footer__result-button").off("click", updateDataInSearchFormEbon);
        $("#submit_button #search, #s_q #search, #suchen4, #valid.btn").off("click", updateDataInSearchForm);

    }

    return {
        ifPreselectedCarChosenSerp: ifPreselectedCarChosenSerp,
        settingPreselectedCarAbTesting: settingPreselectedCarAbTesting,
        enablePreselectedCarAbTesting: enablePreselectedCarAbTesting,
        disablePreselectedCarAbTesting: disablePreselectedCarAbTesting
    }

})($);

$(document).ready(function () {
    if (window.localStorage.getItem('enablePreselectedCarAbTesting')) {
        PreselectedCarABTestingJS.settingPreselectedCarAbTesting();
        PreselectedCarABTestingJS.ifPreselectedCarChosenSerp();
    }
});
